import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const EmployeeHoliday = React.lazy(() =>
  import("@/pages/holiday/EmoloyeeHoliday")
);
const ViewAll = React.lazy(() => import("@/pages/holiday/ViewAll"));
const RestrictedHoliday = React.lazy(() =>
  import("@/pages/holiday/RestrictedHoliday")
);
const Holiday = React.lazy(() => import("@/pages/holiday/Holiday"));

const Leave = [
  // {
  //   path: "holiday",
  //   element: (
  //     <SuspenseWrapper>
  //       <EmployeeHoliday />
  //     </SuspenseWrapper>
  //   ),
  // },
  {
    path: "empHolidays",
    element: (
      <SuspenseWrapper>
        <ViewAll />
      </SuspenseWrapper>
    ),
  },
  {
    path: "empRestrictedHolidays",
    element: (
      <SuspenseWrapper>
        <RestrictedHoliday />
      </SuspenseWrapper>
    ),
  },
  {
    path: "empViewHolidays",
    element: (
      <SuspenseWrapper>
        <Holiday />
      </SuspenseWrapper>
    ),
  },
  {},
];

export default Leave;
